$autocomplete-cursor: default !default;
$autocomplete-color: MenuText !default;
$autocomplete-bg: Menu !default;
$autocomplete-border-width: 1px !default;
$autocomplete-border-color: WindowFrame !default;
$autocomplete-item-padding-x: 1px !default;
$autocomplete-item-padding-t: 0 !default;
$autocomplete-item-padding-b: 1px !default;
$autocomplete-item-selected-color: HighlightText !default;
$autocomplete-item-selected-bg: Highlight !default;
$autocomplete-item-hover-color: $autocomplete-color !default;
$autocomplete-item-hover-bg: gainsboro !default;

/* Dropdown layout */

.af-autocomplete {
  display: none;
  z-index: 1000;
  list-style-type: none;
  padding: 0;
  cursor: $autocomplete-cursor;
  color: $autocomplete-color;
  background-color: $autocomplete-bg;
  border: $autocomplete-border-width solid $autocomplete-border-color;

  li {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    padding-top: $autocomplete-item-padding-t;
    padding-right: $autocomplete-item-padding-x;
    padding-bottom: $autocomplete-item-padding-b;
    padding-left: $autocomplete-item-padding-x;

    &.--selected {
      color: $autocomplete-item-selected-color !important;
      background-color: $autocomplete-item-selected-bg !important;
    }

    &:hover {
      color: $autocomplete-item-hover-color;
      background-color: $autocomplete-item-hover-bg;
    }

    .--highlight {
      font-weight: bold;
    }
  }

  &.--open {
    display: initial;
  }
}
